<template>
  <div
    id="my-slider"
    :se-min="minThreshold"
    :se-step="step"
    :se-min-value="min"
    :se-max-value="max"
    :se-max="maxThreshold"
    class="slider"
  >
    <div class="slider-touch-left">
      <span></span>
    </div>
    <div class="slider-touch-right">
      <span></span>
    </div>
    <div class="slider-line">
      <span></span>
    </div>
  </div>
</template>

<script>
import RangeSlider from './RangeSlider'
import { ref, defineComponent, onMounted } from 'vue'
export default defineComponent({
  name: 'DoubleRangeSlider',
  emits: ['trigger','update:min','update:max'],
  props: {
    minThreshold: {
      type: Number,
      default: 100,
    },
    maxThreshold: {
      type: Number,
      default: 1000,
    },
    step: {
      type: Number,
      default: 1,
    },
    min: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      required: true,
    },
  },
  setup: (props, { emit }) => {
    const instance = ref(undefined)

    const updateValues = (min, max) => {
      emit('update:min', parseInt(min))
      emit('update:max', parseInt(max))
      emit('trigger')
    }

    onMounted(() => {
      instance.value = new RangeSlider('my-slider')
      instance.value.didChanged = (min, max) => updateValues(min, max)
    })

    return { updateValues }
  },
})
</script>

<style lang="scss">
.slider {
  display: block;
  position: relative;
  width: 100%;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
  .slider-touch-left,
  .slider-touch-right {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    display: block;
    position: absolute;
    height: 16px;
    width: 16px;
    top: 0;
    z-index: 2;
  }
  .slider-touch-left span,
  .slider-touch-right span {
    display: block;
    width: 100%;
    height: 100%;
    background: $blue-branding;
    border: 1px solid $blue-branding;
    border-radius: 50%;
  }
  .slider-line {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    position: absolute;
    width: calc(100% - 15px);
    left: 6px;
    top: 6px;
    height: 4px;
    border-radius: 2px;
    background: rgba($blue-branding, 0.4);
    z-index: 0;
    overflow: hidden;
    span {
      display: block;
      height: 100%;
      width: 0%;
      background: $blue-branding;
    }
  }
}
</style>
